import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sjtj",
  "use": "icon-sjtj-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sjtj\"><path d=\"M438.857143 508.571429l312 312q-60.571429 61.714286-141.428571 96t-170.571429 34.285714q-119.428571 0-220.285714-58.857143t-159.714286-159.714286-58.857143-220.285714 58.857143-220.285714 159.714286-159.714286 220.285714-58.857143l0 435.428571zm106.857143 3.428571l441.714286 0q0 89.714286-34.285714 170.571429t-96 141.428571zm405.142857-73.142857l-438.857143 0 0-438.857143q119.428571 0 220.285714 58.857143t159.714286 159.714286 58.857143 220.285714z\" p-id=\"33573\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sjtj.svg
// module id = 2jt8
// module chunks = 61